import type { Trip } from '../../types/trips/Trips';
import apiFetch from '../../core/fetch';

const INITIAL_BOOK_INSTABOOK_STATE: InstabookFormData = {
  adults: 0,
  children: 0,
  infants: 0,
  seniors: 0,
  pickup_time: '',
  instabookId: undefined,
};

const SET_INSTABOOK_DETAILS = 'common/instabook/SET_INSTABOOK_DETAILS';

export const setInstabookDetails = (instabook: InstabookFormData) => ({
  type: SET_INSTABOOK_DETAILS,
  instabook,
} as const);

type InstabookAction = ReturnType<typeof setInstabookDetails>;

export default function instabookReducer(
  // eslint-disable-next-line @typescript-eslint/default-param-last
  instabook = INITIAL_BOOK_INSTABOOK_STATE,
  action: InstabookAction,
) {
  switch (action.type) {
    case SET_INSTABOOK_DETAILS:
      return action.instabook;
    default:
      return instabook;
  }
}

export type InstabookFormData = {
  instabookId?: number;
  adults: number;
  seniors: number;
  infants: number;
  children: number;
  pickup_time: string;
};

export const bookInstabookCall = async ({
  instabookId,
  ...formData
}: InstabookFormData): Promise<Trip> => {
  const response = await apiFetch(
    `/instabook/trips/${instabookId}/book/`,
    {
      method: 'PATCH',
      body: JSON.stringify(formData),
    },
  );
  if (!response.ok) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw response;
  }
  const trip = await response.json();

  return trip;
};
